import ForAuthor from 'assets/Icons/Partnership/forAuthor';
import ForBrands from 'assets/Icons/Partnership/forBrands';
import ForColleges from 'assets/Icons/Partnership/forColleges';
import ForCorporates from 'assets/Icons/Partnership/forCorporates';
import ForEducators from 'assets/Icons/Partnership/forEducators';
import ForPublishers from 'assets/Icons/Partnership/forPublishers';
import ForSchools from 'assets/Icons/Partnership/forSchools';
import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { PartnershipIdEnum } from '@/components/Layout/ProductDropdown';

interface Props {
  className?: string;
  onSelect?: (id: string) => void;
}

const TargetedForSection: FC<Props> = ({ className, onSelect }) => {
  const list = [
    {
      id: 1,
      nameId: PartnershipIdEnum.AUTHORS,
      title: (
        <>
          For
          <br />
          Authors
        </>
      ),
      titlePhone: <>For Authors</>,
      svg: <ForAuthor className='md:h-[71px] h-[61px]' />,
    },
    {
      id: 2,
      nameId: PartnershipIdEnum.BRANDS,
      title: (
        <>
          For
          <br />
          Brands
        </>
      ),
      titlePhone: <>For Brands</>,
      svg: (
        <ForBrands className='lg:h-[61px] md:h-[61px] h-[63px] pb-[5px] md:mt-0 mt-2.5 md:mb-0 -mb-2' />
      ),
    },
    {
      id: 3,
      nameId: PartnershipIdEnum.PUBLISHERS,
      title: (
        <>
          For
          <br />
          Publishers
        </>
      ),
      titlePhone: <>For Publishers</>,
      svg: <ForPublishers className='h-[53px]' />,
    },
    {
      id: 4,
      nameId: PartnershipIdEnum.CORPORATES,
      title: (
        <>
          For
          <br />
          Corporates
        </>
      ),
      svg: <ForCorporates className='md:h-[60px] h-[50px]' />,
    },
    {
      id: 5,
      nameId: PartnershipIdEnum.EDUCATORS,
      title: (
        <>
          For
          <br />
          Educators
        </>
      ),
      svg: <ForEducators className='h-[50px]' />,
    },
    {
      id: 6,
      nameId: PartnershipIdEnum.COLLEGES,
      title: (
        <>
          For
          <br />
          Colleges
        </>
      ),
      svg: <ForColleges className='md:h-[62px] h-[50px]' />,
    },
    {
      id: 7,
      nameId: PartnershipIdEnum.SCHOOLS,
      title: (
        <>
          For
          <br />
          Schools
        </>
      ),
      svg: <ForSchools className='h-[50px]' />,
    },
  ];
  return (
    <>
      <div
        className={twMerge(
          'md:grid hidden xl:grid-cols-7 grid-cols-4 gap-3 ',
          className,
        )}
      >
        {list.map((i, index) => (
          <div
            onClick={() => onSelect?.(i.nameId)}
            key={index}
            className={twMerge(
              'flex border border-[#2b2b2b] rounded-lg bg-[#131313] justify-between gap-1',
              i?.id === 1 && 'items-end pe-2.5 ',
              i?.id === 2 && 'items-end',
              i?.id === 3 && ' items-center pe-2.5',
              i?.id === 4 && ' items-center pe-2.5',
              i?.id === 5 && ' items-center pe-2',
              i?.id === 6 && ' items-center pe-4',
              i?.id === 7 && ' items-center pe-3',
              'hover:cursor-pointer hover:bg-grayZl-900',
            )}
          >
            <p className='ps-[15px] py-[17px] text-grayZl-400 xl:text-base lg:text-base text-sm   font-medium'>
              {i.title}
            </p>
            {i.svg}
          </div>
        ))}
      </div>
      <div
        className={twMerge(
          'md:hidden grid grid-cols-3 gap-2.5 ',
          className,
          'mb-4',
        )}
      >
        {list.slice(0, 3).map((i, index) => (
          <div
            key={index}
            onClick={() => onSelect?.(i.nameId)}
            className='flex flex-col justify-center gap-1.5'
          >
            <div
              key={index}
              className={twMerge(
                'flex border border-[#2b2b2b] rounded-lg bg-[#131313] justify-center gap-4 flex-1',
                i?.id === 1 && 'items-end pt-1',
                i?.id === 2 && 'justify-end',
                i?.id === 3 && ' items-center pe-2.5',
                i?.id === 4 && ' items-center pe-2',
                i?.id === 5 && ' items-center pe-2',
                i?.id === 6 && ' items-center pe-4',
                i?.id === 7 && ' items-center pe-3',
              )}
            >
              {i.svg}
            </div>
            <p className='text-grayZl-400 text-xs text-center'>
              {i?.titlePhone}
            </p>
          </div>
        ))}
      </div>
      <div className={twMerge('md:hidden grid grid-cols-2 gap-3 ', className)}>
        {list.slice(-4).map((i, index) => (
          <div
            onClick={() => onSelect?.(i.nameId)}
            key={index}
            className={twMerge(
              'flex border border-[#2b2b2b] rounded-lg bg-[#131313] justify-between gap-2.5',
              i?.id === 1 && 'items-end pe-2.5 ',
              i?.id === 2 && '',
              i?.id === 3 && ' items-center pe-2.5',
              i?.id === 4 && ' items-center pe-2',
              i?.id === 5 && ' items-center pe-2',
              i?.id === 6 && ' items-center pe-4',
              i?.id === 7 && ' items-center pe-3',
            )}
          >
            <p className='ps-[10px] pt-[12px] pb-[16px] text-grayZl-400 xl:text-base lg:text-base text-xs/5'>
              {i.title}
            </p>
            {i.svg}
          </div>
        ))}
      </div>
    </>
  );
};

export default TargetedForSection;
